import { render, staticRenderFns } from "./VesselMonitoringBay.vue?vue&type=template&id=3b380bc4&scoped=true"
import script from "./VesselMonitoringBay.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringBay.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringBay.vue?vue&type=style&index=0&id=3b380bc4&prod&scoped=true&lang=css"
import style1 from "./VesselMonitoringBay.vue?vue&type=style&index=1&id=3b380bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b380bc4",
  null
  
)

export default component.exports